import i18n from '../../../i18n';

const getDefaultState = () => ({
  items: [
    {
      subheading: i18n.t('menu.booking.title'),
      type: 'booking',
      pages: [
        {
          title: i18n.t('menu.booking.pages.info.title'),
          to: { name: 'BookingInfo', params: { bookingId: ':bookingId' } },
          icon: 'shopping_bag',
          exact: true,
        },
        {
          title: i18n.t('menu.booking.pages.ski.title'),
          to: '',
          icon: 'filter_hdr',
          exact: false,
          subpages: [
            {
              title: i18n.t('menu.booking.pages.ski.rental.title'),
              to: { name: 'SkiRental', params: { bookingId: ':bookingId' } },
              icon: 'launch',
              exact: false,
            },
            {
              title: i18n.t('menu.booking.pages.ski.pass.title'),
              to: { name: 'SkiPass', params: { bookingId: ':bookingId' } },
              icon: 'launch',
              exact: false,
            },
            {
              title: i18n.t('menu.booking.pages.ski.school.title'),
              to: { name: 'SkiSchool', params: { bookingId: ':bookingId' } },
              icon: 'launch',
              exact: false,
            },
          ],
        },
      ],
    },
    {
      subheading: i18n.t('menu.general.title'),
      pages: [
        {
          title: i18n.t('menu.general.pages.dashboard.title'),
          to: { name: 'Index' },
          icon: 'ballot',
          exact: true,
        },
        {
          title: i18n.t('menu.general.pages.twenty.title'),
          href: process.env.TWENTY_FRONT_PAGE,
          icon: 'launch',
          exact: false,
        },
      ],
    },
    {
      subheading: i18n.t('menu.stats.title'),
      pages: [
        {
          title: i18n.t('menu.stats.pages.stats.title'),
          to: { name: 'SalesStats' },
          icon: 'bar_chart',
          exact: false,
        },
      ],
    },
    {
      subheading: i18n.t('menu.gift-voucher.title'),
      pages: [
        {
          title: i18n.t('menu.gift-voucher.pages.title'),
          to: { name: 'GiftVoucher' },
          icon: 'mail',
          exact: false,
        },
      ],
    },
    {
      subheading: 'Triggers',
      pages: [
        {
          title: 'Templates',
          to: { name: 'TriggerTemplates' },
          icon: 'text_snippet',
          exact: false,
        },
        {
          title: 'Rules',
          to: { name: 'TriggerRules' },
          icon: 'settings',
          exact: false,
        },
        {
          title: 'Lists',
          to: { name: 'TriggerLists' },
          icon: 'lists',
          exact: false,
        },
      ],
    },
    {
      subheading: 'Affiliates',
      pages: [
        {
          title: 'Manage',
          to: { name: 'Affiliates' },
          icon: 'outbound',
          exact: false,
        },
      ],
    },
  ],
  breadcrumbs: undefined,
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/nav/defaultState.js